import { FC } from 'react';

type Props = {
	className?: string;
};

const DoorIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#EAEAEA'
			className={className}>
			<path
				d='M3.60156 7.76352C3.60156 6.10497 3.60156 5.27571 3.88766 4.60221C4.12664 4.03962 4.50381 3.55674 4.9791 3.20488C5.54809 2.78364 6.3117 2.63531 7.83893 2.33862C9.42698 2.0301 10.2211 1.87584 10.839 2.12166C11.3524 2.32587 11.7848 2.71156 12.0648 3.21468C12.4017 3.82033 12.4017 4.68265 12.4017 6.4073V13.5929C12.4017 15.3175 12.4017 16.1799 12.0648 16.7855C11.7848 17.2886 11.3524 17.6743 10.839 17.8785C10.2211 18.1244 9.42698 17.97 7.83893 17.6615C6.3117 17.3648 5.54809 17.2165 4.9791 16.7953C4.50381 16.4435 4.12664 15.9606 3.88766 15.3979C3.60156 14.7245 3.60156 13.8952 3.60156 12.2366V7.76352Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M12.3984 16.2388C13.5563 16.3592 15.1184 16.7295 15.9485 15.671C16.3985 15.0972 16.3985 14.2231 16.3985 12.4749V7.52545C16.3985 5.77723 16.3985 4.90312 15.9485 4.32933C15.1184 3.27082 13.5563 3.64113 12.3984 3.76151'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M10 10.8002V9.2002'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15.6016 16.1812H18.0016'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2 16.4004H4.40002'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default DoorIcon;
